<ng-container *ngIf="!notListed; else typed">
    <mat-form-field appearance="outline" class="picker-field">
        <mat-label>{{ label }}</mat-label>
        <input matInput [ngModel]="search" (ngModelChange)="onSearch($event)" [matAutocomplete]="schemeList"
            placeholder="Start typing, e.g. Discovery" autocomplete="off">
        <mat-autocomplete #schemeList="matAutocomplete" [displayWith]="displayScheme"
            (optionSelected)="$event.option.value === null ? chooseNotListed() : selectScheme($event.option.value)">
            <mat-option *ngFor="let s of matches" [value]="s">{{ s.name }}</mat-option>
            <mat-option [value]="null" class="not-listed-option">{{ notListedLabel }}</mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field *ngIf="scheme && scheme.options.length > 1" appearance="outline" class="picker-field">
        <mat-label>Plan and option</mat-label>
        <mat-select [value]="option" (selectionChange)="selectOption($event.value)">
            <mat-option *ngFor="let o of scheme.options" [value]="o">{{ optionLabel(o) }}</mat-option>
        </mat-select>
    </mat-form-field>

    <button mat-button type="button" class="picker-switch" (click)="chooseNotListed()">{{ notListedLabel }}</button>
</ng-container>

<ng-template #typed>
    <mat-form-field appearance="outline" class="picker-field">
        <mat-label>Medical aid name</mat-label>
        <input matInput [ngModel]="freeAid" (ngModelChange)="freeTextChanged($event, freePlan)" placeholder="As it appears on the card">
    </mat-form-field>
    <mat-form-field appearance="outline" class="picker-field">
        <mat-label>Plan</mat-label>
        <input matInput [ngModel]="freePlan" (ngModelChange)="freeTextChanged(freeAid, $event)">
    </mat-form-field>
    <button mat-button type="button" class="picker-switch" (click)="chooseFromList()">Choose from the list instead</button>
</ng-template>
